import React from 'react';

import { Cover } from '@qality/common-components/src/atoms/Cover';

import { useTestCaseRepositoryFiltersContext } from '../TestCaseRepositoryFilters';
import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider';
import TestCaseRepositorySubfolders from '../TestCaseRepositorySubfolders/TestCaseRepositorySubfolders';
import { TestCaseRepositoryTable } from '../TestCaseRepositoryTable';
import { TestCaseRepositoryCoverActions } from '../TestCaseRepositoryTable/TestCaseRepositoryCoverActions';
import {
  ContainerStyled,
  WrapperStyled,
} from './TestCaseRepositoryContent.styled';

export default function TestCaseRepositoryContent(): JSX.Element {
  const { isFilterApplied, undoFilters, applyFilters } =
    useTestCaseRepositoryFiltersContext();
  const { currentView, currentFolder } = useTestCaseRepositoryFoldersContext();

  const isCoverVisible = !isFilterApplied && currentView !== 'all-test-cases';

  return (
    <ContainerStyled>
      <Cover isVisible={isCoverVisible}>
        <TestCaseRepositoryCoverActions
          onFilterButtonClick={applyFilters}
          onUndoButtonClick={undoFilters}
        />
      </Cover>
      <WrapperStyled isCovered={isCoverVisible}>
        <TestCaseRepositorySubfolders />
        <TestCaseRepositoryTable folder={currentFolder} />
      </WrapperStyled>
    </ContainerStyled>
  );
}
